import React, { useState, useRef, useEffect } from "react";
import "./HourlyPremiumQuoteForm.css";
import Loader from "../../../../Template/Loader/Loader";
import CommonMessageModal from "../../../CommonMessageModal/CommonMessageModal";
import { createHourlyOrEditingQuote } from "../../../../utils/APIs/bookingApis";
import { useNavigate } from "react-router-dom";
import NavigationButtons from "../../../../Template/NavigationButtons/NavigationButtons";
import QuoteDatePicker from "../../../PersonalizedQuotePage/QuoteDatePicker";
import { FaCalendarAlt } from "react-icons/fa";

const metroCities = [
  "Ahmedabad", "Amritsar", "Bengaluru", "Bhopal", "Bhubaneswar", "Chandigarh",
  "Chennai", "Coimbatore", "Dehradun", "Delhi", "Faridabad", "Ghaziabad",
  "Gurugram", "Guwahati", "Hyderabad", "Indore", "Jaipur", "Jalandhar",
  "Kanpur", "Kochi", "Kolkata", "Lucknow", "Ludhiana", "Madurai", "Meerut",
  "Mumbai", "Mysuru", "Nagpur", "Nashik", "New Delhi", "Noida", "Patna",
  "Pune", "Raipur", "Rajkot", "Ranchi", "Surat", "Thane", "Thiruvananthapuram",
  "Vadodara", "Varanasi", "Vijayawada", "Visakhapatnam", "Other"
];

const HourlyPremiumQuoteForm = () => {
  const navigate = useNavigate();

  const services = [
    "Wedding Shoot",
    "Maternity & Baby Shoot",
    "Event Shoot",
    "Fashion Shoot",
    "Product Shoot",
    "Food Shoot",
    "Automobile Shoot",
    "Corporate Shoot",
    "Sports Shoot"
  ];

  const requirementsList = [
    "Photography",
    "Videography",
    "Lightening setup",
    "Editing"
  ];

  const [formData, setFormData] = useState({
    clientName: "",
    eventType: "", // Category
    startDate: "", // Date
    location: "",  // City
    photographyRequirements: "", // Requirement
    phoneNumber: "",
    email: "",
  });

  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [showStartPicker, setShowStartPicker] = useState(false);
  const categoryDropdownRef = useRef(null);

  // Dropdown States for City
  const [showCityDropdown, setShowCityDropdown] = useState(false);
  const [citySearchTerm, setCitySearchTerm] = useState("");
  const [isOtherCity, setIsOtherCity] = useState(false);
  const cityDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        categoryDropdownRef.current &&
        !categoryDropdownRef.current.contains(event.target)
      ) {
        setShowCategoryDropdown(false);
      }
      if (cityDropdownRef.current && !cityDropdownRef.current.contains(event.target)) {
        setShowCityDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filteredCities = metroCities
    .filter((city) => city.toLowerCase().includes(citySearchTerm.toLowerCase()))
    .sort((a, b) => {
      if (a === "Other") return 1;
      if (b === "Other") return -1;
      return a.localeCompare(b);
    });

  const handleModalClose = () => {
    setShowMessage(false);
    if (isSuccess) {
      navigate("/myProfile", {
        state: { openTab: "quotes" },
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCategorySelect = (category) => {
    setFormData((prev) => ({ ...prev, eventType: category }));
    setShowCategoryDropdown(false);
  };


  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return date;
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.clientName || !formData.eventType || !formData.startDate || !formData.location || !formData.photographyRequirements) {
      setMessage("Please fill in all required fields.");
      setIsSuccess(false);
      setShowMessage(true);
      return;
    }

    const payload = {
      name: formData.clientName,
      category: formData.eventType,
      date: formatDate(formData.startDate),
      city: formData.location,
      requirement: formData.photographyRequirements,
      serviceCategory: "hourly",
      subCategoryType: "Premium",
      subCategory: "Premium"
    };

    try {
      setLoading(true);
      const response = await createHourlyOrEditingQuote(payload);
      setMessage(response?.data?.message || "Quote submitted successfully");
      setIsSuccess(true);
      setShowMessage(true);
    } catch (error) {
      setMessage(
        error?.response?.data?.message ||
          "Something went wrong. Please try again."
      );
      setIsSuccess(false);
      setShowMessage(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="premium-quote-wrapper d-flex justify-content-center align-items-center">
        <div className="premium-overlay"></div>
        <NavigationButtons />
        
        <div className="container premium-container">
          <div className="text-center mb-5">
            <h1 className="premium-title">
              Request Your Elite Hourly Experience
            </h1>
            <p className="premium-subtitle">Tailored perfection for those who demand the extraordinary</p>
          </div>

          <div className="premium-quote-card mx-auto">
            <form onSubmit={handleSubmit}>
              
              <div className="premium-row">
                <label className="premium-label">
                  Client Name <span className="gold-star">*</span>
                </label>
                <input
                  type="text"
                  name="clientName"
                  className="premium-input"
                  placeholder="Ex. John Doe"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="premium-row">
                <label className="premium-label">
                  Elite Category <span className="gold-star">*</span>
                </label>
                <div className="premium-dropdown-wrapper" ref={categoryDropdownRef} style={{ position: "relative" }}>
                  {/* Hidden input for HTML5 required validation */}
                  <input
                    type="text"
                    value={formData.eventType}
                    required
                    onChange={() => {}}
                    onInvalid={(e) => e.target.setCustomValidity("Please select a category")}
                    onInput={(e) => e.target.setCustomValidity("")}
                    style={{ position: "absolute", opacity: 0, pointerEvents: "none", width: "100%", height: "100%", zIndex: -1 }}
                  />
                  <button
                    type="button"
                    className="premium-input premium-dropdown-btn"
                    onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
                  >
                    {formData.eventType || "Select Category"}
                    <span className="premium-dropdown-arrow"></span>
                  </button>

                  {showCategoryDropdown && (
                    <div className="premium-dropdown-menu">
                      {services.map((service) => (
                        <div
                          key={service}
                          className="premium-dropdown-item"
                          onClick={() => handleCategorySelect(service)}
                        >
                          {service}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="premium-row">
                <label className="premium-label">
                  Event Date <span className="gold-star">*</span>
                </label>
                <div style={{ position: "relative", flex: 1 }}>
                  <input
                    type="text"
                    name="startDate"
                    value={formData.startDate ? (() => {
                      const d = new Date(formData.startDate);
                      if (isNaN(d.getTime())) return formData.startDate;
                      const day = String(d.getDate()).padStart(2, "0");
                      const month = String(d.getMonth() + 1).padStart(2, "0");
                      const year = d.getFullYear();
                      return `${day} - ${month} - ${year}`;
                    })() : ""}
                    placeholder="Select event date"
                    className="premium-input"
                    style={{ width: "100%", cursor: "pointer", paddingRight: "45px" }}
                    onClick={() => setShowStartPicker(true)}
                    onFocus={() => setShowStartPicker(true)}
                    readOnly
                    required
                  />
                  <FaCalendarAlt 
                    style={{ 
                      position: "absolute", 
                      right: "20px", 
                      top: "50%", 
                      transform: "translateY(-50%)", 
                      color: "rgba(255, 255, 255, 0.5)",
                      pointerEvents: "none",
                      fontSize: "18px"
                    }} 
                  />
                </div>
              </div>

              {showStartPicker && (
                <QuoteDatePicker
                  onCancel={() => setShowStartPicker(false)}
                  onSet={(date) => {
                    setFormData((prev) => ({ ...prev, startDate: date }));
                    setShowStartPicker(false);
                  }}
                  initialDateStr={formData.startDate}
                  label="Select event date"
                  minBookingDaysAhead={1}
                />
              )}

              <div className="premium-row">
                <label className="premium-label">
                  Event City <span className="gold-star">*</span>
                </label>
                <div className="premium-dropdown-wrapper" ref={cityDropdownRef}>
                  {isOtherCity ? (
                    <input
                      type="text"
                      className="premium-input"
                      style={{ width: "100%" }}
                      placeholder="Enter your city name"
                      value={formData.location}
                      onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                      onBlur={() => { if (!formData.location) setIsOtherCity(false); }}
                      required
                    />
                  ) : (
                    <>
                      <input
                        type="text"
                        className="premium-input"
                        style={{ width: "100%" }}
                        placeholder="Search or select city"
                        value={formData.location}
                        onFocus={() => setShowCityDropdown(true)}
                        onChange={(e) => {
                          setFormData({ ...formData, location: e.target.value });
                          setCitySearchTerm(e.target.value);
                          setShowCityDropdown(true);
                        }}
                        required
                      />
                      {showCityDropdown && (
                        <div className="premium-dropdown-menu">
                          {filteredCities.map((city, index) => (
                            <div
                              key={index}
                              className="premium-dropdown-item"
                              onClick={() => {
                                if (city === "Other") {
                                  setIsOtherCity(true);
                                  setFormData({ ...formData, location: "" });
                                } else {
                                  setFormData({ ...formData, location: city });
                                }
                                setCitySearchTerm("");
                                setShowCityDropdown(false);
                              }}
                            >
                              {city}
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>

              <div className="premium-row">
                <label className="premium-label">
                  Elite Requirements <span className="gold-star">*</span>
                </label>
                <div className="premium-options-group">
                  {requirementsList.map((req) => (
                    <label key={req} className="premium-option-item">
                      <input
                        type="radio"
                        name="photographyRequirements"
                        value={req}
                        checked={formData.photographyRequirements === req}
                        onChange={handleChange}
                        required
                      />
                      <span className="premium-radio-label">{req}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="text-center mt-5">
                <button type="submit" className="premium-submit-btn">
                  Submit
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>

      <CommonMessageModal
        show={showMessage}
        onClose={handleModalClose}
        message={message}
      />
    </>
  );
};

export default HourlyPremiumQuoteForm;
